<template>
  <ConfirmModal :has-header="false" :data-e2e="ModalCypressAttribute.modals.DELETE_MODAL">
    <template #body>
      <slot v-if="$slots.body" name="body" />
      <span v-else-if="itemName">
        {{ $t('core.are-you-sure') }}
        <strong>{{ itemName }}</strong>
        ?
      </span>
      <span v-else>
        {{ $t('core.are-want-to') }}
      </span>
    </template>
    <template #footer>
      <template v-if="!$slots.footer">
        <button
          class="button is-primary is-light m-r-8"
          type="button"
          @click="onCancel"
          :data-e2e="ModalCypressAttribute.buttons.CANCEL"
        >
          {{ $t('core.no-cancel') }}
        </button>
        <ButtonView
          class="button is-danger"
          :loading="isLoading"
          @click="confirmFn"
          :data-e2e="ModalCypressAttribute.buttons.CONFIRM"
        >
          {{ $t('auth.yes-delete') }}
        </ButtonView>
      </template>
      <slot v-else name="footer"></slot>
    </template>
  </ConfirmModal>
</template>

<script>
import { ModalCypressAttribute } from '/@/modules/core/app/constants/ModalCypressAttribute';
import ToastService from '/@/modules/core/ui/services/ToastService';
import { ModalMixin } from '/@/modules/core/ui/mixins/ModalMixin';
import ConfirmModal from '/@/modules/core/ui/components/ConfirmModal.vue';
import ButtonView from '@/modules/core/ui/components/wrappers/ButtonView.vue';
import { BaseEntityService } from '/@/modules/core/app/services/abstracts/BaseEntityService';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'DeleteModal',
  emits: ['on-cancel', 'on-delete'],
  mixins: [ModalMixin],
  components: {
    ButtonView,
    ConfirmModal
  },
  props: {
    deleteSuccessText: {
      type: String
    },
    itemName: {
      type: String
    },
    service: {
      type: BaseEntityService
    },
    itemId: {
      type: Number,
      required: true
    },
    deleteFn: {
      type: Function
    }
  },
  static: {
    ModalCypressAttribute
  },
  data() {
    return {
      isLoading: false
    };
  },
  methods: {
    onCancel() {
      this.$emit('on-cancel');
      this.close();
    },
    async confirmFn() {
      this.isLoading = true;
      try {
        if (this.deleteFn) {
          await this.deleteFn(this);
        } else {
          await this.service.deleteEntity(this.itemId);
          ToastService.show(
            this.deleteSuccessText || `<b>${this.itemName || ''}</b> successfully deleted.`
          );
        }
        this.$emit('on-delete');
        this.close();
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>
